// src/theme/ThemeProvider.jsx
import { createContext, useContext, useEffect, useState } from "react";
import { applyThemeToRoot } from "./applyTheme";

const API_BASE = import.meta.env.VITE_API_BASE; // e.g. https://admin.onecare.com

const ThemeContext = createContext({ ready: false });
export const useThemeReady = () => useContext(ThemeContext);

export function ThemeProvider({ children }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const hostname = window.location.hostname;
    const cacheKey = `ava-theme:${hostname}`;
    const clinicId = resolveClinicId();

    // already applied synchronously by the index.html script if cache existed —
    // mark ready immediately so children don't block on network
    if (localStorage.getItem(cacheKey)) setReady(true);

    fetch(`${API_BASE}/api/femcare/theme/?clinic=${clinicId}`)
      .then((res) => res.json())
      .then((data) => {
        applyThemeToRoot(data.theme.shades);
        localStorage.setItem(cacheKey, JSON.stringify(data.theme.shades));
        setReady(true);
      })
      .catch(() => setReady(true)); // fail open — CSS fallback vars cover this
  }, []);

  return <ThemeContext.Provider value={{ ready }}>{children}</ThemeContext.Provider>;
}

function resolveClinicId() {
  return window.location.hostname; // swap for your real resolution logic
}